<template>
    <div class="layout-container">
        <Navs></Navs>
        <div class="content-wrapper">
            <router-view />
        </div>
        <Bottom></Bottom>
    </div>
</template>

<script>
export default {
    name: "Layout"
}
</script>

<style scoped>
.layout-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    width: 100%;
}

.content-wrapper {
    flex: 1;
    width: 100%;
}
</style>